import React from 'react'
import PropTypes from 'prop-types'
import { getFormattedUrlByFormat } from 'shared/helpers/VideoUrlsHelper'

const VideoIframeRenderer = (props) => {
  const src = getFormattedUrlByFormat(props.type, props.url)

  return <iframe src={src} title={props.title} allowFullScreen />
}

VideoIframeRenderer.propTypes = {
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default VideoIframeRenderer